export const isDmStagingResponse = (value) => {
    if (typeof value !== 'object' || value === null)
        return false;
    const r = value;
    return ((r.batch === null || typeof r.batch?.sourceSha256 === 'string') &&
        Array.isArray(r.items) &&
        r.items.every((raw) => {
            if (typeof raw !== 'object' || raw === null)
                return false;
            const i = raw;
            return ((i.paymentStatus === undefined ||
                i.paymentStatus === null ||
                typeof i.paymentStatus === 'string') &&
                (i.allocatedAmount === undefined ||
                    i.allocatedAmount === null ||
                    /^\d+\.\d{2}$/.test(i.allocatedAmount)) &&
                (i.unappliedAmount === undefined ||
                    i.unappliedAmount === null ||
                    /^\d+\.\d{2}$/.test(i.unappliedAmount)) &&
                Number.isInteger(i.year) &&
                Number.isInteger(i.month) &&
                typeof i.memberReference === 'string' &&
                (i.sourceObservation === null || typeof i.sourceObservation === 'string') &&
                typeof i.memberLabel === 'string' &&
                typeof i.sourceSheet === 'string' &&
                typeof i.sourceCell === 'string' &&
                (i.amount === null || /^-?\d+\.\d{2}$/.test(i.amount ?? '')));
        }) &&
        Array.isArray(r.years) &&
        Number.isInteger(r.totalItems) &&
        Number.isInteger(r.page) &&
        Number.isInteger(r.pageSize) &&
        Number.isInteger(r.totalPages));
};
export const isStageDmResponse = (value) => typeof value === 'object' &&
    value !== null &&
    typeof value.batch?.sourceSha256 === 'string' &&
    typeof value.idempotent === 'boolean';
